import React from "react";
import { NavLink } from "react-router-dom";

interface RegistrationNavLinksProps {
    id: string;
    path: string;
    tabLabel: string;
}

const RegistrationNavLink = ({ path, tabLabel, id }: RegistrationNavLinksProps) => {
    return (
        <li id={id} data-testid="registration-nav-link" role="tab" className="register-tab">
            <NavLink to={path} end>
                {tabLabel}
            </NavLink>
        </li>
    );
};

export default RegistrationNavLink;
